"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ConnectInbox = _interopRequireDefault(require("InboxConnectUtils/ConnectInbox"));

var _constants = require("composer-lib/lib/constants");

var _utils = require("composer-lib/lib/utils");

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UIConfirmModal = _interopRequireDefault(require("UIComponents/dialog/UIConfirmModal"));

var _UISettings = _interopRequireDefault(require("composer-lib/data/model/UISettings"));

var renderMessage = (0, _utils.getMessageRenderer)('composer-lib.googleAuthModal');

var _default = (0, _createReactClass.default)({
  displayName: "GoogleAuthModal",
  propTypes: {
    dismissGoogleAuthModal: _propTypes.default.func.isRequired,
    showGoogleAuthError: _propTypes.default.func.isRequired,
    uiSettings: _propTypes.default.instanceOf(_UISettings.default).isRequired,
    updateNewGoogleAccount: _propTypes.default.func.isRequired
  },
  handleConnect: function handleConnect() {
    var _this$props = this.props,
        dismissGoogleAuthModal = _this$props.dismissGoogleAuthModal,
        showGoogleAuthError = _this$props.showGoogleAuthError,
        updateNewGoogleAccount = _this$props.updateNewGoogleAccount;
    dismissGoogleAuthModal();

    _ConnectInbox.default.connectWithOptions({
      requestGroup: _constants.CONNECT_INBOX_REQUEST_GROUP,
      portalId: _PortalIdParser.default.get()
    }).then(function (resp) {
      return updateNewGoogleAccount(resp.payload.emailAddress);
    }, showGoogleAuthError);
  },
  render: function render() {
    var _this$props2 = this.props,
        dismissGoogleAuthModal = _this$props2.dismissGoogleAuthModal,
        uiSettings = _this$props2.uiSettings;

    if (!uiSettings.showGoogleAuthModal) {
      return null;
    }

    return _react.default.createElement(_UIConfirmModal.default, {
      confirmLabel: renderMessage('confirmButton'),
      description: renderMessage('body'),
      message: renderMessage('header'),
      onConfirm: this.handleConnect,
      onReject: dismissGoogleAuthModal,
      rejectLabel: renderMessage('cancelButton'),
      rejectUse: "secondary",
      width: 500
    });
  }
});

exports.default = _default;
module.exports = exports.default;